module.exports = __webpack_public_path__ + "img/perfil-generico-03.aea6e335.png";